export default __webpack_public_path__ + "static/media/appstore.f894a17e.svg";